import InnerTabs, { TabPane } from './Tabs';
import './style/index.less';
var Tabs = InnerTabs;
Tabs.TabPane = TabPane;
export { TabPane };
export default Tabs;